(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9814],{

/***/ 26308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContactForm; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./src/components/Alert/Alert.tsx + 1 modules
var Alert = __webpack_require__(60585);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(26208);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/contact.service.ts
var contact_service = __webpack_require__(20644);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/ContactForm/ContactForm.elements.tsx



var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Background",
  componentId: "sc-y2oqks-0"
})(["background:", ";margin-bottom:", ";"], function (props) {
  return props.withoutBackground ? props.theme.colors.white : props.theme.colors.darkLight;
}, (0,polished_esm/* rem */.hO)(240));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Wrapper",
  componentId: "sc-y2oqks-1"
})(["padding:", ";margin-top:", ";display:flex;flex-direction:column;align-items:center;@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(20));
var Form = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Form",
  componentId: "sc-y2oqks-2"
})(["background:", ";padding:", ";border-radius:", ";margin-bottom:", ";box-shadow:0 5px 10px 0 rgba(0,0,0,0.15);"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(-200));
var FormFieldsStyles = (0,styled_components_browser_esm/* css */.iv)(["width:100%;padding:", ";margin-bottom:", ";border:1px solid ", ";border-radius:", ";display:block;&.error{margin-bottom:0;border-color:", ";}@media (min-width:", "px){width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(8), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.danger;
}, theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(700));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "ContactFormelements__Input",
  componentId: "sc-y2oqks-3"
})(["", " height:", ";"], FormFieldsStyles, (0,polished_esm/* rem */.hO)(50));
var TextArea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
  displayName: "ContactFormelements__TextArea",
  componentId: "sc-y2oqks-4"
})(["", " height:", ";"], FormFieldsStyles, (0,polished_esm/* rem */.hO)(150));
var ErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__ErrorMessage",
  componentId: "sc-y2oqks-5"
})(["margin:", " 0 ", " 0;display:block;font-size:", ";color:", ";"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.textBase;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.danger;
});
var GlobalErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__GlobalErrorMessage",
  componentId: "sc-y2oqks-6"
})(["color:", ";padding-top:", ";margin-bottom:-", ";display:block;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.danger;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(10));
var Agreement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Agreement",
  componentId: "sc-y2oqks-7"
})(["margin:", " 0;"], (0,polished_esm/* rem */.hO)(35));
var AgreementLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ContactFormelements__AgreementLink",
  componentId: "sc-y2oqks-8"
})(["color:", ";text-decoration:unset;cursor:pointer;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
});
var SuccessMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__SuccessMessage",
  componentId: "sc-y2oqks-9"
})(["color:", ";padding-top:", ";display:block;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.green;
}, (0,polished_esm/* rem */.hO)(20));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ContactForm/ContactForm.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ContactFormTemplate = function ContactFormTemplate(_ref) {
  var withoutBackground = _ref.withoutBackground;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var nameInputRef = (0,react.useRef)();
  var emailInputRef = (0,react.useRef)();
  var phoneInputRef = (0,react.useRef)();
  var messageInputRef = (0,react.useRef)();

  var _useGoogleReCaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)(),
      executeRecaptcha = _useGoogleReCaptcha.executeRecaptcha;

  var _useState = (0,react.useState)(false),
      hasAgreement = _useState[0],
      setHasAgreement = _useState[1];

  var _useState2 = (0,react.useState)(false),
      hasNameError = _useState2[0],
      setHasNameError = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      hasEmailError = _useState3[0],
      setHasEmailError = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      hasMessageError = _useState4[0],
      setMessageError = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      hasSentError = _useState5[0],
      setHasSentError = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isSent = _useState7[0],
      setIsSent = _useState7[1];

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _nameInputRef$current, _emailInputRef$curren, _emailInputRef$curren2, _messageInputRef$curr;

      var hasError, _nameInputRef$current2, _nameInputRef$current3, _emailInputRef$curren3, _phoneInputRef$curren, _phoneInputRef$curren2, _messageInputRef$curr2, generatedToken, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setHasNameError(false);
              setHasEmailError(false);
              setMessageError(false);
              setHasSentError(false);
              setIsSent(false);
              hasError = false;

              if (!((nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current = nameInputRef.current) === null || _nameInputRef$current === void 0 ? void 0 : _nameInputRef$current.value) === '')) {
                _context.next = 9;
                break;
              }

              setHasNameError(true);
              return _context.abrupt("return");

            case 9:
              if (!((emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren = emailInputRef.current) === null || _emailInputRef$curren === void 0 ? void 0 : _emailInputRef$curren.value) === '' || !constants/* EMAIL_REGEX.test */.CU.test(emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren2 = emailInputRef.current) === null || _emailInputRef$curren2 === void 0 ? void 0 : _emailInputRef$curren2.value))) {
                _context.next = 12;
                break;
              }

              setHasEmailError(true);
              return _context.abrupt("return");

            case 12:
              if (!((messageInputRef === null || messageInputRef === void 0 ? void 0 : (_messageInputRef$curr = messageInputRef.current) === null || _messageInputRef$curr === void 0 ? void 0 : _messageInputRef$curr.value) === '')) {
                _context.next = 15;
                break;
              }

              setMessageError(true);
              return _context.abrupt("return");

            case 15:
              if (!hasError) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return");

            case 17:
              _context.prev = 17;
              setIsLoading(true);
              _context.next = 21;
              return executeRecaptcha();

            case 21:
              generatedToken = _context.sent;
              data = _objectSpread(_objectSpread(_objectSpread({}, (nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current2 = nameInputRef.current) === null || _nameInputRef$current2 === void 0 ? void 0 : _nameInputRef$current2.value) && {
                name: nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current3 = nameInputRef.current) === null || _nameInputRef$current3 === void 0 ? void 0 : _nameInputRef$current3.value
              }), {}, {
                email: emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren3 = emailInputRef.current) === null || _emailInputRef$curren3 === void 0 ? void 0 : _emailInputRef$curren3.value
              }, (phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren = phoneInputRef.current) === null || _phoneInputRef$curren === void 0 ? void 0 : _phoneInputRef$curren.value) && {
                phone: phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren2 = phoneInputRef.current) === null || _phoneInputRef$curren2 === void 0 ? void 0 : _phoneInputRef$curren2.value
              }), {}, {
                message: messageInputRef === null || messageInputRef === void 0 ? void 0 : (_messageInputRef$curr2 = messageInputRef.current) === null || _messageInputRef$curr2 === void 0 ? void 0 : _messageInputRef$curr2.value,
                token: generatedToken
              });
              _context.next = 25;
              return contact_service/* contactApi.contact */.e.contact(data);

            case 25:
              setIsSent(true);
              setIsLoading(false);
              emailInputRef.current.value = '';
              nameInputRef.current.value = '';
              phoneInputRef.current.value = '';
              messageInputRef.current.value = '';
              _context.next = 36;
              break;

            case 33:
              _context.prev = 33;
              _context.t0 = _context["catch"](17);
              setHasSentError(true);

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 33]]);
    }));

    return function handleClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Background, {
    withoutBackground: withoutBackground,
    children: [hasSentError && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
      type: Alert/* AlertTypes.error */.d.error,
      message: t('contact.error')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
            tagType: Title/* TitleTagTypes.H3 */.Z.H3,
            isBlack: true,
            children: t('contact.contact.title')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: nameInputRef,
            placeholder: t('contact.form.name.placeholder'),
            className: "".concat(hasNameError ? 'error' : '')
          }), hasNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.name.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: emailInputRef,
            placeholder: t('contact.form.email.placeholder'),
            className: "".concat(hasEmailError ? 'error' : '')
          }), hasEmailError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.email.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: phoneInputRef,
            placeholder: t('contact.form.phone.placeholder')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextArea, {
            ref: messageInputRef,
            placeholder: t('contact.form.message.placeholder'),
            className: "".concat(hasMessageError ? 'error' : '')
          }), hasMessageError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.message.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Agreement, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Checkbox/* default */.Z, {
              name: "agreement",
              onChange: function onChange() {
                return setHasAgreement(!hasAgreement);
              },
              checked: hasAgreement,
              children: ["S\xFAhlas\xEDm s", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(AgreementLink, {
                href: "https://www.zakon.sk/ochrana-osobnych-udajov.xhtml",
                children: "podmienkami spracovania osobn\xFDch \xFAdajov"
              })]
            })
          }), (hasNameError || hasEmailError || hasMessageError) && /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalErrorMessage, {
            children: t('contact.form.error')
          }), !isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            isLoading: isLoading,
            disabled: !hasAgreement,
            marginTop: 25,
            onClick: handleClick,
            text: "Odosla\u0165"
          }), isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessMessage, {
            children: t('contact.form.sent')
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var ContactForm = (ContactFormTemplate);

/***/ }),

/***/ 67450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Exhibitors_Exhibitors; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/utils/person.utils.ts
var person_utils = __webpack_require__(19033);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/lecturer.service.ts
var lecturer_service = __webpack_require__(4034);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Exhibitors/Exhibitors.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__Wrapper",
  componentId: "sc-1deaujm-0"
})(["padding:", " 0 ", " 0;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(60));
var Exhibitors = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__Exhibitors",
  componentId: "sc-1deaujm-1"
})(["padding:", " 0;"], (0,polished_esm/* rem */.hO)(20));
var Exhibitor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__Exhibitor",
  componentId: "sc-1deaujm-2"
})(["display:flex;flex-direction:column;width:100%;padding:0;margin-bottom:", ";cursor:pointer;@media (min-width:", "px){margin-left:", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(30));
var ExhibitorTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exhibitorselements__ExhibitorTitle",
  componentId: "sc-1deaujm-3"
})(["padding:", " 0 ", " 0;font-weight:", ";text-align:center;width:", ";@media (min-width:", "px){width:", ";}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(145), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(170));
var ExhibitorAnnotation = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Exhibitorselements__ExhibitorAnnotation",
  componentId: "sc-1deaujm-4"
})(["color:", ";display:block;text-align:center;line-height:1.5;width:", ";@media (min-width:", "px){width:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(145), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(170));
var ExhibitorImage = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "Exhibitorselements__ExhibitorImage",
  componentId: "sc-1deaujm-5"
})(["width:", ";height:", ";border-radius:", ";object-fit:cover;@media (min-width:", "px){width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(145), (0,polished_esm/* rem */.hO)(210), (0,polished_esm/* rem */.hO)(16), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(170), (0,polished_esm/* rem */.hO)(240));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Exhibitors/Exhibitors.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ExhibitorsTemplate = function ExhibitorsTemplate() {
  var _lecturers$sort;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)([]),
      lecturers = _useState[0],
      setLecturers = _useState[1];

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: false,
    responsive: [{
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false
      }
    }, {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false
      }
    }]
  };
  (0,react.useEffect)(function () {
    lecturer_service/* lecturerApi.list */.r.list().then(function (_ref) {
      var data = _ref.data;
      setLecturers(data.results);
    });
  }, []);
  return (lecturers === null || lecturers === void 0 ? void 0 : lecturers.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
      withPadding: true,
      mobileSidePadding: 20,
      id: "vyberLektorov",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        isBlack: true,
        children: t('homepage.lecturer.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Exhibitors, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, _objectSpread(_objectSpread({}, settings), {}, {
          children: lecturers === null || lecturers === void 0 ? void 0 : (_lecturers$sort = lecturers.sort(function (a, b) {
            return a.in_carousel - b.in_carousel;
          })) === null || _lecturers$sort === void 0 ? void 0 : _lecturers$sort.map(function (lecturer, key) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(Exhibitor, {
              onClick: function onClick() {
                return router.push("".concat(constants/* ROUTES.LECTURER */.Z6.LECTURER, "/").concat(lecturer.slug));
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ExhibitorImage, {
                width: 0,
                height: 0,
                alt: (0,person_utils/* formatLecturerName */.v)(lecturer),
                loader: function loader(_ref2) {
                  var src = _ref2.src;
                  return src;
                },
                src: lecturer.photo ? "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(lecturer._key) : "".concat((0,url_utils/* publicAssets */.VK)('/avatar_height.jpg'))
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ExhibitorTitle, {
                children: [lecturer.name, " ", lecturer.surname]
              }), (lecturer === null || lecturer === void 0 ? void 0 : lecturer.position) && /*#__PURE__*/(0,jsx_runtime.jsx)(ExhibitorAnnotation, {
                children: lecturer.position
              })]
            }, key);
          })
        }))
      })]
    })
  });
};

/* harmony default export */ var Exhibitors_Exhibitors = (ExhibitorsTemplate);

/***/ }),

/***/ 99950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ skolenia_na_mieru; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/CompanyCoursesProcess/CompanyCourses.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyCourseselements__Wrapper",
  componentId: "sc-13cq9lo-0"
})(["display:flex;gap:", ";flex-wrap:wrap;margin:", " 0 ", " 0;justify-content:center;@media (min-width:", "px){flex-direction:row;justify-content:space-between;}"], (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(35), theme/* breakpoints.sm */.A.sm);
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CompanyCourseselements__Section",
  componentId: "sc-13cq9lo-1"
})(["display:flex;flex-direction:column;width:100%;margin-bottom:", ";padding:", " ", ";border-radius:", ";border:1px solid ", ";@media (min-width:", "px){width:23%;margin-bottom:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(16), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(45));
var SectionIcon = (0,styled_components_browser_esm/* default */.ZP)(IconTemplate/* IconTemplate */._).withConfig({
  displayName: "CompanyCourseselements__SectionIcon",
  componentId: "sc-13cq9lo-2"
})(["display:block;margin-bottom:", ";svg{width:", ";height:", ";}&.board,&.feedback{svg{width:", ";height:", ";margin-top:", ";}}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(50), (0,polished_esm/* rem */.hO)(50), (0,polished_esm/* rem */.hO)(-10));
var SectionLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "CompanyCourseselements__SectionLabel",
  componentId: "sc-13cq9lo-3"
})(["color:", ";font-size:", ";line-height:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.grey;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(30));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/CompanyCoursesProcess/CompanyCoursesProcess.tsx









var CompanyCoursesProcessTemplate = function CompanyCoursesProcessTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H2 */.Z.H2,
      isBlack: true,
      children: t('companyCourses.process.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionIcon, {
          name: Icon/* Icons.Envelop */.PJ.Envelop
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          dangerouslySetInnerHTML: {
            __html: t('companyCourses.process.section1.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionIcon, {
          name: Icon/* Icons.Calendar */.PJ.Calendar
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          dangerouslySetInnerHTML: {
            __html: t('companyCourses.process.section2.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionIcon, {
          className: "board",
          name: Icon/* Icons.Board */.PJ.Board
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          dangerouslySetInnerHTML: {
            __html: t('companyCourses.process.section3.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionIcon, {
          className: "feedback",
          name: Icon/* Icons.Feedback */.PJ.Feedback
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          dangerouslySetInnerHTML: {
            __html: t('companyCourses.process.section4.label')
          }
        })]
      })]
    })]
  });
};

/* harmony default export */ var CompanyCoursesProcess = (CompanyCoursesProcessTemplate);
// EXTERNAL MODULE: ./src/components/ContactForm/ContactForm.tsx + 1 modules
var ContactForm = __webpack_require__(26308);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
;// CONCATENATED MODULE: ./src/components/Education/Education.elements.tsx



var WrapperCats = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Educationelements__WrapperCats",
  componentId: "sc-103doc9-0"
})(["padding:", " 0 ", " 0;@media (min-width:", "px){padding:", " 0 ", " 0;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(80), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(0));
var Education_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Educationelements__Wrapper",
  componentId: "sc-103doc9-1"
})(["padding-bottom:", ";@media (min-width:", "px){display:flex;flex-direction:row;justify-content:space-between;}"], (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.md */.A.md);
var Categories = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Educationelements__Categories",
  componentId: "sc-103doc9-2"
})(["display:flex;flex-direction:row;justify-content:center;flex-wrap:wrap;margin-bottom:", ";gap:", ";@media (min-width:", "px){justify-content:center;flex-wrap:unset;}"], (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(15), theme/* breakpoints.sm */.A.sm);
var Category = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "Educationelements__Category",
  componentId: "sc-103doc9-3"
})(["background:none;border:1px solid ", ";border-radius:", ";padding:", " ", ";cursor:pointer;width:45%;&.active{border-color:", ";font-weight:", ";}@media (min-width:", "px){width:auto;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(20), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
}, theme/* breakpoints.sm */.A.sm);
var Areas = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Educationelements__Areas",
  componentId: "sc-103doc9-4"
})(["padding:0 ", ";margin-top:", ";@media (min-width:", "px){display:flex;flex-direction:row;}@media (min-width:", "px){padding:0;}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.xs */.A.xs, theme/* breakpoints.md */.A.md);
var Column = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Educationelements__Column",
  componentId: "sc-103doc9-5"
})(["display:flex;flex-direction:column;@media (min-width:", "px){width:", ";}"], theme/* breakpoints.xs */.A.xs, (0,polished_esm/* rem */.hO)(350));
var Area = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Educationelements__Area",
  componentId: "sc-103doc9-6"
})(["display:flex;flex-direction:row;align-items:center;font-size:", ";line-height:", ";color:", ";margin-bottom:", ";padding-right:", ";svg{width:", ";height:", ";margin-right:", ";margin-bottom:", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(25), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(18), (0,polished_esm/* rem */.hO)(18), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(-2));
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Educationelements__Image",
  componentId: "sc-103doc9-7"
})(["display:block;width:55%;margin:", " auto;@media (min-width:", "px){width:35%;margin:0;}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md);
;// CONCATENATED MODULE: ./src/components/Education/Education.tsx











var CATEGORY_IDS;

(function (CATEGORY_IDS) {
  CATEGORY_IDS[CATEGORY_IDS["TAXES_AND_ACCOUNTING"] = 0] = "TAXES_AND_ACCOUNTING";
  CATEGORY_IDS[CATEGORY_IDS["WAGES_AND_HR"] = 1] = "WAGES_AND_HR";
  CATEGORY_IDS[CATEGORY_IDS["GOVERNMENT"] = 2] = "GOVERNMENT";
  CATEGORY_IDS[CATEGORY_IDS["OTHER_LEGISLATION"] = 3] = "OTHER_LEGISLATION";
})(CATEGORY_IDS || (CATEGORY_IDS = {}));

var EducationTemplate = function EducationTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(CATEGORY_IDS.TAXES_AND_ACCOUNTING),
      activeCategoryId = _useState[0],
      setActiveCategoryId = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    withPadding: true,
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(WrapperCats, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        tagType: Title/* TitleTagTypes.H2 */.Z.H2,
        isBlack: true,
        children: t('about.education.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Categories, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Category, {
          onClick: function onClick() {
            return setActiveCategoryId(CATEGORY_IDS.TAXES_AND_ACCOUNTING);
          },
          className: activeCategoryId === CATEGORY_IDS.TAXES_AND_ACCOUNTING ? 'active' : '',
          children: t('about.education.label1')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Category, {
          onClick: function onClick() {
            return setActiveCategoryId(CATEGORY_IDS.WAGES_AND_HR);
          },
          className: activeCategoryId === CATEGORY_IDS.WAGES_AND_HR ? 'active' : '',
          children: t('about.education.label2')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Category, {
          onClick: function onClick() {
            return setActiveCategoryId(CATEGORY_IDS.GOVERNMENT);
          },
          className: activeCategoryId === CATEGORY_IDS.GOVERNMENT ? 'active' : '',
          children: t('about.education.label3')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Category, {
          onClick: function onClick() {
            return setActiveCategoryId(CATEGORY_IDS.OTHER_LEGISLATION);
          },
          className: activeCategoryId === CATEGORY_IDS.OTHER_LEGISLATION ? 'active' : '',
          children: t('about.education.label4')
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Education_elements_Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Areas, {
          children: [activeCategoryId === CATEGORY_IDS.TAXES_AND_ACCOUNTING && /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area1')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area2')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area3')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area4')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area5')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area6')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area7')]
            })]
          }), activeCategoryId === CATEGORY_IDS.TAXES_AND_ACCOUNTING && /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area8')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area9')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area10')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area11')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area12')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.other')]
            })]
          }), activeCategoryId === CATEGORY_IDS.WAGES_AND_HR && /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area13')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area14')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area15')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area16')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area17')]
            })]
          }), activeCategoryId === CATEGORY_IDS.WAGES_AND_HR && /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area18')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area19')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area20')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area21')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area22')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.other')]
            })]
          }), activeCategoryId === CATEGORY_IDS.GOVERNMENT && /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area23')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area24')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area25')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area26')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area27')]
            })]
          }), activeCategoryId === CATEGORY_IDS.GOVERNMENT && /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area28')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area29')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area30')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area38')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.other')]
            })]
          }), activeCategoryId === CATEGORY_IDS.OTHER_LEGISLATION && /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area31')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area32')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area33')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area34')]
            })]
          }), activeCategoryId === CATEGORY_IDS.OTHER_LEGISLATION && /*#__PURE__*/(0,jsx_runtime.jsxs)(Column, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area35')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area36')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area37')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.area38')]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Area, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                name: Icon/* Icons.ArrowRight */.PJ.ArrowRight
              }), t('about.education.other')]
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: (0,url_utils/* publicAssets */.VK)('/education.svg')
      })]
    })]
  });
};

/* harmony default export */ var Education = (EducationTemplate);
// EXTERNAL MODULE: ./src/components/Exhibitors/Exhibitors.tsx + 1 modules
var Exhibitors = __webpack_require__(67450);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(94951);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
;// CONCATENATED MODULE: ./src/components/Partners/Partners.elements.tsx



var Partners_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Partnerselements__Wrapper",
  componentId: "sc-12h6j8h-0"
})(["padding:", " 0 ", " 0;@media (min-width:", "px){padding:", " 0 ", " 0;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(80), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(80), (0,polished_esm/* rem */.hO)(80));
var CarouselWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Partnerselements__CarouselWrapper",
  componentId: "sc-12h6j8h-1"
})(["padding:", ";"], (0,polished_esm/* rem */.hO)(20));
var Client = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Partnerselements__Client",
  componentId: "sc-12h6j8h-2"
})(["display:flex;justify-content:center;align-items:center;padding:", ";padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40));
var ClientImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Partnerselements__ClientImage",
  componentId: "sc-12h6j8h-3"
})(["width:70%;margin:0 auto;"]);
;// CONCATENATED MODULE: ./src/components/Partners/Partners.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var PartnersTemplate = function PartnersTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var clients = ['/spp.jpg', '/stredoslovenska-distribucna.jpg', '/nafta.jpg', '/hyundai.jpg', '/antolin.jpg', '/continental.jpg', '/billa.jpg', '/uprsv.jpg', '/vub.jpg', '/mobis.jpg', '/idea-dss.jpg', '/eustream.jpg', '/dolvap.jpeg', '/kastiel-mojmirovce.jpeg'];
  var settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    responsive: [{
      breakpoint: theme/* breakpoints.sm */.A.sm,
      settings: {
        slidesToShow: 2,
        dots: true
      }
    }, {
      breakpoint: theme/* breakpoints.md */.A.md,
      settings: {
        slidesToShow: 3,
        dots: true
      }
    }]
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    withPadding: true,
    mobileSidePadding: 20,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Partners_elements_Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        isBlack: true,
        children: t('customTraining.clients.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.Z, _objectSpread(_objectSpread({}, settings), {}, {
          children: clients.map(function (client, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(Client, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ClientImage, {
                src: (0,url_utils/* publicAssets */.VK)(client)
              })
            }, index);
          })
        }))
      })]
    })
  });
};

/* harmony default export */ var Partners = (PartnersTemplate);
// EXTERNAL MODULE: ./src/ui/Divider/Divider.tsx + 1 modules
var Divider = __webpack_require__(96770);
// EXTERNAL MODULE: ./src/ui/Hero/Hero.tsx + 1 modules
var Hero = __webpack_require__(29135);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
;// CONCATENATED MODULE: ./src/pages/skolenia-na-mieru.tsx


















var CompanyCourses = function CompanyCourses() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.companyCourses.title'),
      description: t('seo.companyCourses.description'),
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK,
      openGraph: {
        images: [{
          url: "https://profivzdelavanie.sk".concat((0,url_utils/* publicAssets */.VK)('/og-konferencia.png'))
        }]
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Hero/* default */.Z, {
      titleKey: "companyCourses.hero.title",
      imageKey: "company_courses_hero.webp",
      descriptionKey: "companyCourses.hero.paragraph",
      listKeys: ['companyCourses.hero.paragraph1', 'companyCourses.hero.paragraph2', 'companyCourses.hero.paragraph3', 'companyCourses.hero.paragraph4']
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyCoursesProcess, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Exhibitors/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Education, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Divider/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Partners, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactForm/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var skolenia_na_mieru = (CompanyCourses);

/***/ }),

/***/ 20644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ contactApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var CONTACT = 'pv/contact';
var WITHDRAWAL = 'pv/contact/withdrawal';
var COMPANY_COURSES_ORDER = 'pv/contact/company-course-form';
var contactApi = {
  contact: function contact(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(CONTACT, data);
  },
  withdrawal: function withdrawal(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(WITHDRAWAL, data);
  },
  companyCoursesOrder: function companyCoursesOrder(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(COMPANY_COURSES_ORDER, data);
  }
};

/***/ }),

/***/ 4034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ lecturerApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var LIST = 'person/list/carousel';
var DETAIL = 'pv/person/slug';
var lecturerApi = {
  list: function list() {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(LIST);
  },
  detail: function detail(slug) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug));
  },
  upcomingTrainings: function upcomingTrainings(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  },
  upcomingConferences: function upcomingConferences(slug, limit, offset) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/upcoming/conferences"), {
      limit: limit,
      offset: offset
    });
  },
  records: function records(slug, limit, offset, excludeEvents) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(DETAIL, "/").concat(slug, "/archived/courses"), {
      limit: limit,
      offset: offset,
      excludeEvents: excludeEvents
    });
  }
};

/***/ }),

/***/ 96770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Divider; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
;// CONCATENATED MODULE: ./src/ui/Divider/Divider.elements.tsx


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Dividerelements__Wrapper",
  componentId: "sc-1b0a3wd-0"
})(["height:1px;width:100%;background:", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, function (prop) {
  return prop.marginTop ? "margin-top: ".concat((0,polished_esm/* rem */.hO)(prop.marginTop)) : '';
}, function (prop) {
  return prop.marginBottom ? "margin-bottom: ".concat((0,polished_esm/* rem */.hO)(prop.marginBottom)) : '';
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Divider/Divider.tsx




var DividerTemplate = function DividerTemplate(_ref) {
  var marginTop = _ref.marginTop,
      marginBottom = _ref.marginBottom;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    marginTop: marginTop,
    marginBottom: marginBottom
  });
};

/* harmony default export */ var Divider = (DividerTemplate);

/***/ }),

/***/ 29135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Wrapper",
  componentId: "sc-1nsgps3-0"
})(["display:flex;padding:", " ", ";max-width:", ";margin:", " auto ", " auto;min-height:", ";flex-direction:column-reverse;@media (min-width:", "px){margin:", " auto ", " auto;}@media (min-width:", "px){flex-direction:row;align-items:center;padding:0;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(500), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.md */.A.md);
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Heroelements__Image",
  componentId: "sc-1nsgps3-1"
})(["width:100%;border-radius:", ";height:auto;margin-top:", ";@media (min-width:", "px){display:block;margin-top:", ";width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(600));
var About = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__About",
  componentId: "sc-1nsgps3-2"
})(["@media (min-width:", "px){padding-left:", ";}"], theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(65));
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Heroelements__Title",
  componentId: "sc-1nsgps3-3"
})(["font-weight:", ";font-size:", ";font-family:", ";padding-bottom:", ";@media (min-width:", "px){font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h3;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (props) {
  return props.withoutBottomPadding ? 0 : (0,polished_esm/* rem */.hO)(30);
}, theme/* breakpoints.md */.A.md, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h2;
});
var Description = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Heroelements__Description",
  componentId: "sc-1nsgps3-4"
})(["font-size:", ";font-weight:", ";padding:", " 0 ", " 0;line-height:", ";color:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h6;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeights.textRegular;
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey;
});
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__Label",
  componentId: "sc-1nsgps3-5"
})(["font-size:", ";line-height:", ";display:flex;margin-bottom:", ";svg{width:", ";height:", ";margin-right:", ";margin-top:", ";polyline{stroke:black;}}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(26), (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(2));
var Benefit = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Benefit",
  componentId: "sc-1nsgps3-6"
})(["display:flex;flex-direction:column;align-items:center;flex-wrap:wrap;width:50%;margin-bottom:", ";@media (min-width:", "px){width:25%;margin-bottom:0;}@media (min-width:", "px){flex-direction:row;}"], (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.lg */.A.lg);
var Benefits = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Benefits",
  componentId: "sc-1nsgps3-7"
})(["display:flex;justify-content:space-between;padding:0 0 ", " 0;flex-wrap:wrap;margin-top:", ";max-width:", ";margin:", " auto ", " auto;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(-40), (0,polished_esm/* rem */.hO)(40));
var BenefitNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__BenefitNumber",
  componentId: "sc-1nsgps3-8"
})(["font-size:", ";font-family:", ";font-weight:700;color:", ";padding-right:", ";white-space:nowrap;"], (0,polished_esm/* rem */.hO)(48), function (_ref9) {
  var theme = _ref9.theme;
  return theme.fonts.fontSecondary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(15));
var BenefitLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__BenefitLabel",
  componentId: "sc-1nsgps3-9"
})(["font-weight:", ";font-size:", ";text-align:center;line-height:", ";@media (min-width:", "px){text-align:left;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontWeights.textBold;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontSizes.textBase;
}, (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.tsx










var HeroTemplate = function HeroTemplate(_ref) {
  var titleKey = _ref.titleKey,
      imageKey = _ref.imageKey,
      listKeys = _ref.listKeys,
      descriptionKey = _ref.descriptionKey,
      withBenefits = _ref.withBenefits;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: (0,url_utils/* publicAssets */.VK)("/".concat(imageKey))
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(About, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          dangerouslySetInnerHTML: {
            __html: t(titleKey)
          },
          withoutBottomPadding: (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && !!descriptionKey
        }), descriptionKey && /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
          dangerouslySetInnerHTML: {
            __html: t(descriptionKey)
          }
        }), (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && (listKeys === null || listKeys === void 0 ? void 0 : listKeys.map(function (listKey, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Label, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              dangerouslySetInnerHTML: {
                __html: t(listKey)
              }
            })]
          }, key);
        }))]
      })]
    }), withBenefits && /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefits, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit1.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit1.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit2.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit2.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit3.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit3.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Benefit, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BenefitNumber, {
          children: t('homepage.benefit4.number')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BenefitLabel, {
          dangerouslySetInnerHTML: {
            __html: t('homepage.benefit4.label')
          }
        })]
      })]
    })]
  });
};

/* harmony default export */ var Hero = (HeroTemplate);

/***/ }),

/***/ 83297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleTagTypes; },
  "C": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.element.tsx



var TitleStyles = (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";padding:", ";", ";", ";@media (min-width:", "px){font-size:", ";line-height:", ";", ";padding:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.$withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0");
}, function (prop) {
  return prop.$isBlack ? "color: ".concat(prop.theme.colors.black, ";") : "color: ".concat(prop.theme.colors.primary, ";");
}, function (prop) {
  return prop.$alignCenter ? 'text-align: center;' : '';
}, theme/* breakpoints.sm */.A.sm, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h3;
}, (0,polished_esm/* rem */.hO)(44), function (prop) {
  return prop.$alignLeft ? 'text-align: left;' : 'text-align: center;';
}, function (prop) {
  return prop.$withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(15), " 0 ").concat((0,polished_esm/* rem */.hO)(60), " 0");
});
var WrapperDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Titleelement__WrapperDiv",
  componentId: "sc-s8z71i-0"
})(["", ""], TitleStyles);
var WrapperH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Titleelement__WrapperH1",
  componentId: "sc-s8z71i-1"
})(["", ""], TitleStyles);
var WrapperH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Titleelement__WrapperH2",
  componentId: "sc-s8z71i-2"
})(["", ""], TitleStyles);
var WrapperH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Titleelement__WrapperH3",
  componentId: "sc-s8z71i-3"
})(["", ""], TitleStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.tsx



var TitleTagTypes;

(function (TitleTagTypes) {
  TitleTagTypes["H1"] = "h1";
  TitleTagTypes["H2"] = "h2";
  TitleTagTypes["H3"] = "h3";
})(TitleTagTypes || (TitleTagTypes = {}));

var TitleTemplate = function TitleTemplate(_ref) {
  var children = _ref.children,
      alignLeft = _ref.alignLeft,
      alignCenter = _ref.alignCenter,
      withoutPadding = _ref.withoutPadding,
      isBlack = _ref.isBlack,
      tagType = _ref.tagType;

  if (tagType === TitleTagTypes.H1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH1, {
      $withoutPadding: withoutPadding,
      $alignLeft: alignLeft,
      $alignCenter: alignCenter,
      $isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH3, {
      $withoutPadding: withoutPadding,
      $alignLeft: alignLeft,
      $alignCenter: alignCenter,
      $isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH2, {
      $withoutPadding: withoutPadding,
      $alignLeft: alignLeft,
      $alignCenter: alignCenter,
      $isBlack: isBlack,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperDiv, {
    $withoutPadding: withoutPadding,
    $alignLeft: alignLeft,
    $alignCenter: alignCenter,
    $isBlack: isBlack,
    children: children
  });
};

/* harmony default export */ var Title = (TitleTemplate);

/***/ }),

/***/ 19033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ formatLecturerName; }
/* harmony export */ });
var formatLecturerName = function formatLecturerName(person) {
  if (!person) return;
  return "".concat(person.titles.before_name ? "".concat(person.titles.before_name, " ") : '').concat(person.name, " ").concat(person.surname).concat(person.titles.after_name ? ", ".concat(person.titles.after_name) : '');
};

/***/ }),

/***/ 96098:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skolenia-na-mieru",
      function () {
        return __webpack_require__(99950);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,6066,5675,4623,9774,2888,179], function() { return __webpack_exec__(96098); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);